import LinkSharer from './LinkSharer'

export default LinkSharer
